import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {QuickTip, Table, DownloadLink} from 'components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';
import {calendarDate} from 'shared/tools';

const FieldValue = observer(({model}) => {
  if (model.field === 'cheque') {
    return <DownloadLink href={`/api/v1/attached_documents/${model.value}`} title={t('nmbr.updates.directory.Download')} />;
  }

  return <div>{model.value}</div>;
});

const COLUMNS = [
  {
    header: 'nmbr.updates.directory.Field',
    width: 6,
    render: model => t(`nmbr.updates.directory.fields.${model.field}`)
  },
  {
    header: 'nmbr.updates.directory.Value',
    width: 6,
    component: FieldValue
  }
];

const EmployeeTable = observer(({nmbrUpdate}) => {
  if (!(nmbrUpdate.hasFieldUpdate('field') ||
      nmbrUpdate.hasFieldUpdate('missing_fields') ||
      nmbrUpdate.hasFieldUpdate('nmbr_validation_error') ||
      nmbrUpdate.hasFieldUpdate('invalid_record') )
  ) {
    return null;
  }

  return (
    <div className='space-y'>
      <div className='h3 medium'><FormattedMessage id='nmbr.updates.directory.Employee Fields'/></div>
      {nmbrUpdate.hasFieldUpdate('field') && <Table
        columns={COLUMNS}
        models={_.filter(nmbrUpdate.fieldUpdates, {updateType: 'field'})}
        showLinks={false}
      />}
      {nmbrUpdate.hasFieldUpdate('missing_fields') && <QuickTip
        trait='error'
        header={t('nmbr.updates.directory.The following required fields have not been filled out for this employee')}
        paragraphs={[
          <ul>
            {nmbrUpdate.fieldUpdatesForType('missing_fields')[0].fields.map(field => <li className='ml2'>
              <FormattedMessage id={`nmbr.errors.missing_fields.${field}`}/>
            </li>)}
          </ul>,
          <FormattedMessage id='nmbr.updates.directory.You may not be able to run payroll for this employee until these fields are updated.'/>
        ]}/>}
      {nmbrUpdate.hasFieldUpdate('nmbr_validation_error') && <QuickTip
        trait='error'
        header={t('nmbr.updates.directory.Some fields could not be processed')}
        paragraphs={[
          <ul>
            {nmbrUpdate.fieldUpdatesForType('nmbr_validation_error')[0].errors.map(error => <li className='ml2'>
              {error}
            </li>)}
          </ul>,
          <FormattedMessage id='nmbr.updates.directory.You may not be able to run payroll for this employee until these fields are updated.'/>
        ]}/>}
      {nmbrUpdate.hasFieldUpdate('invalid_record') && <QuickTip
        trait='error'
        header={t('nmbr.updates.directory.Some employment records could not be processed')}
        paragraphs={[
          t('nmbr.updates.directory.UNSYNCED_PAY_RATES_WARNING'),
          <ul className='ml2'>
            {nmbrUpdate.fieldUpdatesForType('invalid_record').map(field_update => <li>
              {t('nmbr.updates.directory.EMPLOYMENT_RECORD_ERROR', {
                effectiveDate: calendarDate(field_update.effectiveDate),
                recordType: t(`nmbr.errors.record_types.${field_update.recordType}`),
                errors: field_update.translateErrors ? field_update.errors.map(error => t(`nmbr.errors.messages.${error}`)).join(' ') : field_update.errors.join(' ')
              })}
            </li>)}
          </ul>
        ]}/>}
    </div>
  );
});

export default EmployeeTable;
